export default __webpack_public_path__ + "static/media/logo-slickpals.b05fb850.png";